import React from 'react'
import { Grid, Button } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { Formik, Field } from 'formik'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import { semiConfigContext, ProductDetails } from '../Shrna'
import { useShrnaSearchTermLazyQuery } from '@src/queries/ShrnaProductSearchQuery.generated'
import { shrnaRoute, useRouter } from '@src/routes'
import { ActiveLinkType } from '../Enum'
import { initialState } from '../Reducer'
import ValidationErrors from '../../../../Configurators/validations/ValidationErrors'
import { validateText } from '@src/routes/SemiConfigurators/utils/util'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import { SemiConfiguratorValues } from '../../../utils/constants'
import styles from '@src/routes/SemiConfigurators/utils/styles'
import DiscountMessagePage from '@src/routes/SemiConfigurators/utils/DiscountMessagePage'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(8.5, 4, 8.5),
    },
    fontWeight: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'normal',
    },
    buttonconfig: {
      marginTop: theme.spacing(3.5),
    },
    buttonPadding: {
      padding: theme.spacing(2.5, 12.5),
    },
  }
})

interface ManualSearchProps {
  productDetails: ProductDetails
}

const ManualSearch: React.FC<ManualSearchProps> = (props) => {
  const classes = useStyles()
  const globalClasses = styles()
  const intl = useIntl()
  const { state, dispatch } = React.useContext(semiConfigContext)
  const [getShrnaSearchTerm, { data, loading }] = useShrnaSearchTermLazyQuery()
  const { productDetails } = props
  const router = useRouter()
  const value = { ...state.searchValue }
  const [validationMessage, setValidationMessage] = React.useState<string[]>([])
  const [upload, setUpload] = React.useState(false)

  const shrnaSearchResult = async (obj) => {
    await getShrnaSearchTerm({ variables: { input: obj } })
    dispatch({
      type: 'UPDATE_SEARCH_TERM',
      data: obj,
    })
  }

  React.useEffect(() => {
    window.scrollTo(0, 0)
    setUpload(false)
    setValidationMessage([])
    dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    if (state.stepNo) {
      state.traceOnClick = false
      dispatch({ type: 'TRACE_ON_CLICK', data: state.traceOnClick })
    }
    if (state.stepNo === 1) {
      dispatch({
        type: 'CHECK_ACTIVE_LINK',
        data: {
          ...state.checkActiveLink,
          itemSelectionLink: true,
        },
      })
    }
    if (state.stepNo === 2) {
      dispatch({
        type: 'CHECK_ACTIVE_LINK',
        data: {
          ...state.checkActiveLink,
          specificationLink: true,
        },
      })
    }
    if (router !== null && router.query !== null) {
      let term = ''
      term = router.query.term
      if (term) {
        const updateQueryTerm = {
          ...state.searchValue,
          term,
          locale: productDetails.locale,
          region: productDetails.region,
          store: productDetails.store,
        }
        shrnaSearchResult(updateQueryTerm)
      }
    }

    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleShrnaSearch = () => {
    if (!state.stepNo) {
      dispatch({ type: 'TRACE_ON_CLICK', data: false })
    }
    const terms = state.searchValue.term.trim()
    const chips = terms.split(/[\s, ]+/)
    if (!state.searchValue.term) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
      setValidationMessage([intl.formatMessage(messages.CONF_REQUIRED_FIELD)])
      setUpload(true)
    } else if (chips.length > 100) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
      setValidationMessage([intl.formatMessage(messages.CONF_UPLOAD_ERROR_MSG)])
      window.scroll(0, 0)
      setUpload(true)
    }
    const updateCountryCode = {
      ...state.searchValue,
      locale: productDetails.locale,
      region: productDetails.region,
      facet: initialState.searchValue.facet,
      page: 1,
      count: 10,
      order: initialState.searchValue.order,
      term: terms,
      sort: initialState.searchValue.sort,
      store: productDetails.store,
    }
    dispatch({
      type: 'SET_PER_PAGE_COUNT',
      data: initialState.perPageCount,
    })
    dispatch({
      type: 'UPDATE_SEARCH_TERM',
      data: updateCountryCode,
    })
    dispatch({
      type: 'CHECK_ACTIVE_LINK',
      data: {
        ...state.checkActiveLink,
        itemSelectionLink: false,
        specificationLink: false,
      },
    })
    if (chips.length <= 100 && state.searchValue.term) {
      dispatch({ type: 'SET_PAGINATION_PAGE', data: 1 })
      shrnaSearchResult(updateCountryCode)
    }
  }

  const getValue = (event, keys) => {
    dispatch({ type: 'CHECK_FILE_UPLOAD', data: false })
    if (state.stepNo) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
      dispatch({
        type: 'UPDATE_SEARCH_RESPONSE',
        data: initialState.searchResponseJson,
      })
      dispatch({
        type: 'UPDATE_DROPDOWN_RESPONSE',
        data: initialState.shrnaDropDownResponseList,
      })
      dispatch({
        type: 'UPDATE_PRICE_CALL_RESPONSE',
        data: initialState.priceCallResponse,
      })
      dispatch({
        type: 'UPDATE_DROP_DOWN',
        data: initialState.shrnaDropDownValue,
      })
      dispatch({
        type: 'UPDATE_PRICE_CALL',
        data: initialState.priceCallData,
      })
      dispatch({
        type: 'UPDATE_SPECIFICATION_VALUES',
        data: initialState.specificationValues,
      })
      dispatch({
        type: 'UPDATE_PAGINATION_DATA',
        data: initialState.paginationData,
      })
      dispatch({
        type: 'SET_STEP_NO',
        data: initialState.stepNo,
      })
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: initialState.pageError,
      })
    }
    const speciesArr: string[] = state.searchValue.facet
    dispatch({
      type: 'UPDATE_SEARCH_TERM',
      data: {
        ...state.searchValue,
        facet: speciesArr,
      },
    })

    if (!keys.length) {
      let ret = validateText(event.target.value)
      if (event.target.value.endsWith('  ')) {
        ret = event.target.value.replace('  ', ' ')
      }
      dispatch({
        type: 'UPDATE_SEARCH_TERM',
        data: { ...state.searchValue, term: ret },
      })
    }
  }

  React.useEffect(() => {
    if (data !== undefined) {
      if (!data.getShrnaSearchTerm?.serverError) {
        dispatch({
          type: 'UPDATE_SEARCH_RESPONSE',
          data: data.getShrnaSearchTerm,
        })
        if (
          data.getShrnaSearchTerm.count !== null &&
          data.getShrnaSearchTerm.count !== undefined
        ) {
          dispatch({
            type: 'UPDATE_PAGINATION_DATA',
            data: {
              ...state.paginationData,
              totalCount: data.getShrnaSearchTerm.count,
            },
          })
        }
        const url = `${shrnaRoute.index()}?activeLink=${
          ActiveLinkType.SelectClones
        }`
        if (
          data.getShrnaSearchTerm.count === 0 ||
          state.searchValue.term === null
        ) {
          dispatch({
            type: 'SET_PAGE_ERROR',
            data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
          })
          setValidationMessage([
            intl.formatMessage(
              messages.CONF_MANUAL_SEARCH_1_ERROR_POPUP_crispgrna
            ) +
              `${value.term}` +
              intl.formatMessage(
                messages.CONF_MANUAL_SEARCH_2_ERROR_POPUP_crispgrna
              ),
          ])
          setUpload(true)
        }
        if (data !== undefined && data.getShrnaSearchTerm.count) {
          router.push(url)
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: SemiConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  React.useEffect(() => {
    return function cleanupError() {
      dispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
  }, [])

  return (
    <semiConfigContext.Provider value={{ state, dispatch }}>
      <Formik
        initialValues={{ oligoName: '' }}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            actions.setSubmitting(false)
          }, 1000)
        }}
      >
        <div>
          <div className={classes.contentWrapper}>
            <Grid>
              <b>
                <h3>
                  <FormattedMessage {...messages.CONF_SEARCH_GENES} />
                </h3>
              </b>
            </Grid>
            <Grid>
              <h5 className={classes.fontWeight}>
                <FormattedMessage {...messages.CONF_SEARCH_MESSAGE} />
              </h5>
            </Grid>
            <Field
              name="addInfo"
              component={LiquidInputAdapter}
              multiline
              rows={4}
              rowsMax={4}
              className={globalClasses.manualSearchText}
              filled
              onChange={(e) => getValue(e, '')}
              value={state.checkFileUpload ? '' : state.searchValue.term}
            />
            {upload && (
              <div>
                <ValidationErrors errors={validationMessage} />
              </div>
            )}

            <Grid className={classes.buttonconfig}>
              <Button
                color="primary"
                variant="contained"
                onClick={handleShrnaSearch}
                className={classes.buttonPadding}
              >
                {
                  <FormattedMessage
                    {...messages.order_field_label_search_orders}
                  />
                }
              </Button>
            </Grid>
          </div>
          <div className={globalClasses.marginTop3}>
            <DiscountMessagePage />
          </div>
          {loading && <CircleLoader />}
        </div>
      </Formik>
    </semiConfigContext.Provider>
  )
}

export default ManualSearch
